import React from 'react';
import global from '../../http/common';
import './index.css';
import iPhone_cover from '../../static/imgs/iPhone_cover.png';

class HomeVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showVideo: global.isPC(),
      imgVideoSrc: "",
      srcArr: [],
      autoPlay: this.props.autoPlay == false ? false : true,
      playing: false
    };
    this.globalData = {
      timer: null,
      imgVideoPlay: true,
      imgVideoPlayTimeLength: 200
    };
  }
  componentDidMount () {
    if (this.state.autoPlay || !this.state.showVideo) {
      this.play();
    } else {
      this.pause();
    }
  }
  render () {
    let videoStyle = {};
    if (this.props.videoStyle) {
      videoStyle = this.props.videoStyle;
    }
    let className = "home_video_bg";
    if (this.props.className) {
      className = className + " " + this.props.className;
    }
    let contentItem = null;
    let posterImg = null;
    let poster = null;
    if (this.props.type.indexOf("ysxg") == -1 && this.props.type != "design") {
      poster = require("../../static/imgs/imgVideo/" + this.props.type + "/" + "layout_1" + ".png").default;
    }
    if (this.state.showVideo) {
      contentItem = (
        <video ref="homeVideo" className="home_video" style={videoStyle} autoPlay webkit-playsinline="true" playsInline muted loop>
          <source src={this.props.src} type="video/mp4" ></source>
        </video>
      );
      if (this.props.type.indexOf("ysxg") != -1) {
        contentItem = (
          <div className="ysxg_home_video_bg">
            <div className="liuhai"></div>
            <video ref="homeVideo" className="home_video" style={{
              width: "100%",
              height: "auto",
              margin: "0px"
            }} autoPlay webkit-playsinline="true" playsInline muted loop>
              <source src={this.props.src} type="video/mp4" ></source>
            </video>
          </div>
        );
      }
    } else {
      contentItem = (
        <img className="home_video" style={videoStyle} src={this.state.imgVideoSrc}></img>
      );
    }
    if (poster) {
      posterImg = (
        <img src={poster} style={{ maxWidth: "100%", height: "100%", position: "absolute", left: "50%", top: "50%", transform: "translate(-50%,-50%)", display: this.state.playing ? "none" : "block" }}></img>
      )
    }
    return (
      <div className={className}>
        {
          contentItem
        }
        {
          posterImg
        }
      </div>
    );
  }
  play () {
    if (this.state.showVideo) {
      this.playVideo();
    } else {
      this.playImgVideo();
    }
    this.setState({
      playing: true
    });
  }
  pause () {
    if (this.state.showVideo) {
      this.pauseVideo();
    } else {
      this.pauseImgVideo();
    }
    this.setState({
      playing: false
    });
  }
  playVideo () {
    let homeVideo = this.refs.homeVideo;
    if (homeVideo.play instanceof Function) {
      homeVideo.play();
    }
  }
  pauseVideo () {
    let homeVideo = this.refs.homeVideo;
    if (homeVideo.play instanceof Function) {
      homeVideo.pause();
      homeVideo.currentTime = 0;
    }
  }
  playImgVideo () {
    //显示图片模拟视频
    let srcArr = this.getSrcArrByType(this.props.type);
    if (srcArr && srcArr.length) {
      this.setState({
        srcArr: srcArr
      }, () => {
        //显示图片模拟视频
        let srcArr = this.state.srcArr;
        if (srcArr) {
          this.globalData.imgVideoPlay = true;
          this.playImgVideoStep(srcArr, 0);
        }
      })
    }
  }
  pauseImgVideo () {
    this.globalData.imgVideoPlay = false;
  }
  playImgVideoStep (srcArr, index) {
    let src = srcArr[index];
    this.setState({
      imgVideoSrc: src
    });
    if (this.globalData.timer) {
      clearTimeout(this.globalData.timer);
      this.globalData.timer = null;
    }
    if (this.globalData.imgVideoPlay) {
      this.globalData.timer = setTimeout(() => {
        let i = index == srcArr.length - 1 ? 0 : index + 1;
        this.playImgVideoStep(srcArr, i);
      }, this.globalData.imgVideoPlayTimeLength);
    }
  }
  getSrcArrByType (type) {
    let srcArr = [];
    for (let i = 1; i <= 1; i++) {
      let imgName = "layout_" + i;
      srcArr.push(require("../../static/imgs/imgVideo/" + type + "/" + imgName + ".png").default);
    }
    return srcArr;
  }
}
export default HomeVideo;